/** Pure helpers voor de weergave van individuele MSP-profielen. Verzinnen nooit tekst. */

const clean = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

/**
 * Tekst voor de "Over"-kaart. Uitgebreide omschrijving heeft voorrang.
 * Valt alleen terug op de korte pitch als die nog niet in de hero staat,
 * zodat dezelfde pitch nooit dubbel verschijnt.
 */
export function getAboutText(
  uitgebreide?: string | null,
  pitch?: string | null,
  pitchShownInHero = false,
): string | null {
  const full = clean(uitgebreide);
  if (full) return full;
  const p = clean(pitch);
  if (!p || pitchShownInHero) return null;
  return p;
}

/** Alleen niet-lege diensten. */
export function getServices(diensten?: readonly (string | null | undefined)[] | null): string[] {
  return (diensten ?? []).map(clean).filter(Boolean);
}

export function hasServices(diensten?: readonly (string | null | undefined)[] | null): boolean {
  return getServices(diensten).length > 0;
}

/** Max. twee initialen ("Cloud Agent" → "CA"); lege naam → "?". */
export function getInitials(name?: string | null): string {
  const words = clean(name).split(/\s+/).filter((w) => /[\p{L}\p{N}]/u.test(w));
  if (words.length === 0) return '?';
  const first = (w: string) => (w.match(/[\p{L}\p{N}]/u)?.[0] ?? '').toUpperCase();
  if (words.length === 1) return first(words[0]);
  return first(words[0]) + first(words[1]);
}

/** Is er überhaupt compliance-informatie? Zo niet: neutraal "Niet opgegeven". */
export function hasComplianceData(calculatedLevel: unknown, verifiedCertCount: number): boolean {
  const lvl = clean(calculatedLevel);
  return verifiedCertCount > 0 || (lvl !== '' && lvl.toLowerCase() !== 'none');
}
